import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'complaints',
  children: {
    id: {
      path: ':id',
      children: {
        messages: {
          path: 'messages',
        },
      },
    },
  },
} as const satisfies Location
